import { Box, Button, Stack, Tabs } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { ConsignmentItem, TransitGroup } from '@e-origin/shared';

import { classes } from '@styles';
import { TransitViewHouseFormValues } from '../../validateTransitViewHouseForm';
import { GoodsItemData } from './GoodsItemData';
import { GoodsItemDocuments } from './GoodsItemDocuments';
import { GoodsItemStakeholders } from './GoodsItemStakeholders';
import { useTransitViewEditGoodsItemFormInitializer } from './useTransitViewEditGoodsItemFormInitializer';

interface EditGoodsItemProps {
  form: UseFormReturnType<TransitViewHouseFormValues>;
  goodsItemIdx: number;
  houseConsignmentIdx: number;
  onHide: () => void;
  onSave: (goodsItem: ConsignmentItem) => void;
  editDisabled: boolean;
  editDisabledConditionalForArrival: boolean;
}

export const EditGoodsItem: React.FC<EditGoodsItemProps> = ({
  houseConsignmentIdx,
  goodsItemIdx,
  onSave,
  onHide,
  editDisabled,
  editDisabledConditionalForArrival,
  form,
}) => {
  const { goodsItemForm, onSubmit, houseConsignment } = useTransitViewEditGoodsItemFormInitializer({
    houseConsignmentIdx,
    goodsItemIdx,
    form,
    onSave,
    onHide,
  });

  const isArrival = form?.values?.generalInfo?.group === TransitGroup.ARRIVAL;

  return (
    <Stack px="md">
      <Tabs defaultValue="item-data">
        <Tabs.List>
          <Tabs.Tab value="item-data">Item Data</Tabs.Tab>
          {!isArrival && <Tabs.Tab value="stakeholders">Stakeholders</Tabs.Tab>}
          <Tabs.Tab value="documents">Documents</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="item-data">
          <GoodsItemData
            form={form}
            goodsItemForm={goodsItemForm}
            houseConsignment={houseConsignment}
            disabled={editDisabled}
            editDisabledConditionalForArrival={editDisabledConditionalForArrival}
          />
        </Tabs.Panel>
        {!isArrival && (
          <Tabs.Panel value="stakeholders">
            <GoodsItemStakeholders form={form} goodsItemForm={goodsItemForm} houseConsignment={houseConsignment} disabled={editDisabled} />
          </Tabs.Panel>
        )}
        <Tabs.Panel value="documents">
          <GoodsItemDocuments
            form={form}
            goodsItemForm={goodsItemForm}
            houseConsignment={houseConsignment}
            editDisabledConditionalForArrival={editDisabledConditionalForArrival}
            isArrival={isArrival}
          />
        </Tabs.Panel>
      </Tabs>
      <Box className={classes.footer}>
        <Button type="button" onClick={onHide} size="lg" variant="transparent">
          Cancel
        </Button>
        {(!editDisabled || !editDisabledConditionalForArrival) && (
          <Button type="button" onClick={onSubmit} variant="filled" size="lg" data-pw="save-goods-item-btn">
            Save
          </Button>
        )}
      </Box>
    </Stack>
  );
};
